import { APLLoadingPage } from 'legacy/hpscoutso/components/pages/aplCommon/APLLoadingPage'
import { APLWelcomeContent } from 'legacy/hpscoutso/components/pages/aplWelcome/APLWelcomeContent'
import { APLPageLayout } from 'legacy/hpscoutso/layout/aplPageLayout/APLPageLayout'
import React, { useState } from 'react'

export const APLWelcomePage = () => {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <APLPageLayout setIsLoading={setIsLoading} isLoading={isLoading}>
      {isLoading ? <APLLoadingPage /> : <APLWelcomeContent />}
    </APLPageLayout>
  )
}
